import type { FC } from 'react';

import { getStaticPrefix } from '@eneco/common/env';
import { useDevice } from '@eneco/hooks/deviceContext';
import { Box, Image, Stack, Text, useMediaQuery, VisuallyHidden } from '@eneco/sparky';
import { wrap } from '@sitecore/common';
import { StoreButtonsRendering } from '@sitecore/types/manual/StoreButtons';

const StoreButtons: FC<StoreButtonsRendering> = ({ fields, params }) => {
  const { isIOS, isAndroid } = useDevice();
  const buttons = fields?.storeButtonsItem?.fields;
  const displayVariant = params?.variant;
  const alignment = params?.alignment;
  const imageHeight = '48px';
  const imageWidth = displayVariant === 'footer' ? '144px' : '100%';

  const isMobile = !useMediaQuery('md');
  const horizontalAlign = alignment === 'right' && !isMobile ? 'end' : 'start';

  if (!buttons) {
    return null;
  }

  return (
    <Stack gap="2" direction="column" alignX={horizontalAlign}>
      {(fields.title?.value || fields.title?.editable) && (
        <Stack.Item>
          <Box paddingTop="6">
            <Text color="textPrimary" weight="bold">
              {wrap(fields.title)}
            </Text>
          </Box>
        </Stack.Item>
      )}
      <Stack.Item>
        <Stack gap="5" direction={displayVariant === 'footer' ? 'column' : 'row'}>
          {/* On Desktop always show the buttons */}
          {!isAndroid && buttons.iosButtonLink?.value?.href && (
            <Stack.Item>
              <a
                href={buttons.iosButtonLink?.value?.href}
                target={buttons.iosButtonLink?.value?.target}
                rel="noreferrer">
                <VisuallyHidden>{buttons.iosButtonLink?.value?.text}</VisuallyHidden>
                <Image
                  alt={buttons.iosButtonLink?.value?.text || 'Download in de App Store'}
                  height={imageHeight}
                  width={imageWidth}
                  src={`${getStaticPrefix()}/images/eneco/apple-store-badge.png`}
                />
              </a>
            </Stack.Item>
          )}
          {!isIOS && buttons.androidButtonLink?.value?.href && (
            <Stack.Item>
              <a
                href={buttons.androidButtonLink?.value?.href}
                target={buttons.androidButtonLink?.value?.target}
                rel="noreferrer">
                <VisuallyHidden>{buttons.androidButtonLink?.value?.text}</VisuallyHidden>
                <Image
                  alt={buttons.androidButtonLink?.value?.text || 'ONTDEK HET OP Google Play'}
                  height={imageHeight}
                  width={imageWidth}
                  src={`${getStaticPrefix()}/images/eneco/google-play-badge.png`}
                />
              </a>
            </Stack.Item>
          )}
        </Stack>
      </Stack.Item>
    </Stack>
  );
};

export { StoreButtons };
export default StoreButtons;
